module.exports = __webpack_public_path__ + "static/mbdbcms-30ae2d750f9dc78222bd85e6c8126d04.png";